import { Navigate } from 'react-router-dom';
import { useIsAuthenticated, useMsal } from '@azure/msal-react';
import { InteractionStatus } from '@azure/msal-browser';
import LandingPageLayout from '@/components/layouts/LandingPageLayout';
import Landing from '@/pages/Landing';

function LandingView() {
  const { inProgress } = useMsal();
  const isAuthenticated = useIsAuthenticated();
  const isLoading = inProgress === InteractionStatus.Startup;

  if (isLoading) {
    return null;
  }

  if (isAuthenticated) {
    return <Navigate to='/home' replace />;
  } else {
    return (
      <LandingPageLayout>
        <Landing />
      </LandingPageLayout>
    );
  }
}

export default LandingView;
